import {Link} from 'react-router-dom'
import Tooltip from '../../../components/Tooltip/Tooltip'

const OrderBox = ({
  semiHeader,
  header,
  headerLink,
  searchParams,
  tooltip,
  className = '',
}: {
  semiHeader: string
  header: string
  headerLink?: string
  searchParams?: string
  tooltip?: string
  className?: string
}) => {
  return (
    <div className={`border rounded-2 mb-5 ${className}`}>
      <div className='p-4'>
        <div>
          <p className='fs-6 fw-bold mb-3'>{semiHeader}</p>
          {tooltip ? (
            <h3 className='mb-0 fw-bolder fs-4'>
              <Tooltip tooltipText={tooltip} text={header} />
            </h3>
          ) : (
            <h3 className='mb-0 fw-bolder fs-4'>
              {headerLink ? (
                <Link
                  to={{
                    pathname: headerLink,
                    search: searchParams,
                  }}
                  target='_blank'
                  className='text-dark text-decoration-underline text-hover-primary'
                >
                  {header}
                </Link>
              ) : (
                header
              )}
            </h3>
          )}
        </div>
      </div>
    </div>
  )
}

export default OrderBox
